import React from "react";

import { Typography, IconButton } from "@tiny/components";
import { GeolocationDialogProps } from "./MapControls.types";
import { useStyles } from "./MapControls.styles";
import MinusCircleOutline from "@tiny/icons/generated/MinusCircleOutline";
import PlusCircleOutline from "@tiny/icons/generated/PlusCircleOutline";

function GeolocationDialog(props: GeolocationDialogProps) {
  const { reset, zoomIn, zoomOut } = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        variant="h4"
        color="grey"
        tone={900}
        mr={5}
        className={classes.text}
      >
        Zoom in/out
      </Typography>
      <IconButton onClick={zoomOut} className={classes.action} size="large">
        <MinusCircleOutline />
      </IconButton>
      <IconButton onClick={zoomIn} className={classes.action} size="large">
        <PlusCircleOutline />
      </IconButton>
      <IconButton onClick={reset} className={classes.action} size="large">
        Reset
      </IconButton>
    </div>
  );
}

export default React.memo(GeolocationDialog);
